/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ProcessDetailController {
    public static $inject = [
        '$scope',
        '$state',
        '$uibModal',
        'Process',
        'User',
        'toaster',
        'bsLoadingOverlayService',
        'Upload',
    ];

    public schema;
    public form;
    public checkPermission;
    public newComment;
    public user;
    public _path;
    public hasDate;
    public canEdit = false;
    public process: any = {};
    public pickup_person: string;
    private state;
    public docExpenseObj = {
        file: '',
        name: '',
        description: '',
    };
    public fileDirModel = {
        fileName: 'Select a file',
        fileLink: undefined
    };

    public additionalFiles = [];
    constructor(private $scope: angular.IScope,
                private $state: ng.ui.IStateService,
                private $uibModal: any,
                private Process: IProcessService,
                private User: IUserService,
                private toaster: toaster.IToasterService,
                private bsLoadingOverlayService: IBsLoadingService,
                private Upload: any) {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.checkPermission = User.hasPermission;
        this.user = User.getCurrentUser();
        this.state = $state;

        bsLoadingOverlayService.start({referenceId: 'requests_loader'});
        Process.loadProcess($state.params['id'])
            .then((response: any) => {
                this.process = response;

                // Check if user can edit a leave item that has not started the approval process
                if (this.process.transitions.length == 1 &&
                    this.process.type === 'leave' &&

                    // Check if the edit is for the current user or HRM
                    (this.process.employee.id == this.user.userData.id ||
                        this.user.isHRM)) {
                    this.canEdit = true;
                }

                // // Check if user can edit a leave item that has not started the approval process
                // if ( !this.process.transitions.some(t => t.transition !== 'create') )  {
                //   if (this.process.type === 'leave') {
                //     if ( this.process.employee.id == this.user.userData.id || this.user.isHRM ) { // Check if the edit is for the current user or HRM
                //         this.canEdit = true;
                //     }
                //   }
                // }

                if (this.process.extra.additionalFiles !== undefined) { 
                    this.additionalFiles = this.process.extra.additionalFiles;
                }
                this.pickup_person = response.transitions.slice(-1)[0].employee['displayname'];
                this.Process.getDef(this.process.type)
                    .then((def) => {
                        this.Process.getPath(this.process.type, 'init', def.path_to_success)
                            .then((path) => {
                                this._path = path;
                            }
                        );
                    }
                );

                // check if the process has a start date
                if (this.process.extra && this.process.extra.data && this.process.extra.data.start_date) {
                    this.hasDate = true;
                }

                bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
        }, 
        () => {
            this.toaster.pop('error', 'Server error', 'Process cannot be loaded');
        });
    }

    public items(): any {
        if (this.process.extra) {

            /**
             * Assumes the transition is a 3 step process
             * Step 1 is the request
             * Step 2 is the superior approval
             * Step 3 is the hrm approval
             * Possible for Step 2 to be approved by hrm
             */ 
            if (this.process.transitions.length === 3) {

                /** 
                 * if the user approving the request at the second step
                 * matches the user approving the request at the third step
                 * ignore the last step so that the approve step that shows up
                 * only shows up once
                 */
                if (this.process.transitions[2].employee.id === this.process.transitions[1].employee.id) {
                    return this.process.comments.concat(
                        (this.process.transitions).slice(0, 2)
                    );
                }
            }
            return this.process.comments.concat(this.process.transitions);
        }
    }

    public sendComment(): void {
        let that = this;
        if (this.newComment) {
            this.Process.saveComment(this.$state.params['id'], this.newComment)
                .then(() => {
                    let subType = '';
                    if (this.process.type === 'document' || this.process.type === 'leave') {
                        subType = this.process.extra.data['type'];
                    }

                    this.$scope.$emit('$EL', 'requests.item.note.add.'+this.process.type, subType);

                    this.toaster.pop('success', 'Success', 'Comment successfully added');
                    this.process.comments.push({
                        comment: this.newComment,
                        employee: {displayname: this.user.userData.displayname}
                    });
                    this.newComment = '';
                }, 
                () => {
                    this.toaster.pop('error', 'Server error', 'Please try again later');
                }
            );
        }
    }

    public canViewDownload(): Boolean {

        /** 
         * a requestor should never be able to see a document
         * they have requested.. documents are only good when signed
         * and printed out. see #534 for more details
         */
        return !this.process.extra.download
            && this.process.has_download
            && this.checkPermission('org.view_employee')
            && this.user.userData.id !== this.process.employee.id;
    }

    public canDownloadAtCompletion(): Boolean {
        if (this.process && this.process.extra) {
            return this.process.extra.download
                && this.checkPermission('org.view_employee')
                && this.process.allowed_transitions.length === 0
                && this.user.userData.id !== this.process.employee.id;
        } else {
            return false;
        }
    }

    public shouldNotifyForPickup(): Boolean {
        if (this.process && this.process.extra) {
            return this.process.extra.download
                && this.process.extra.finalized
                && this.process.extra.success
                && this.user.userData.id === this.process.employee.id;
        } else {
            return false;
        }
    }

    public canDecide(): Boolean {
        /**
         * a requestor can never decide on their own request
         * by decide we mean either approve or reject, unless the
         * next clearance is admin and the requestor is an admin
         */
        if (this.user.userData.user.clearance === 'admin' &&
            this.process.extra.next_clearances.indexOf('admin') > -1) {
            return true;
        }
        return this.user.userData.id !== this.process.employee.id;
    }

    public hasSuperiorAndPermission(): boolean {
        if (this.User.getCurrentUser().userData.superior === null && this.User.hasPermission('org.change_org')) {
            return false;
        }

        return true;
    }

    public transition(transition_name: any): void {
        let that = this;
        var templateUrl: string = '/static/templates/process/transition_modal.html';
        if (this.process.type === 'warning') {
            if (transition_name === 'acknowledge') {
                templateUrl = '/static/templates/process/acknowledge_modal.html';
            }
        }

        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', 'bsLoadingOverlayService', 
                function ($scope: any, $uibModalInstance: any, toaster: any, bsLoadingOverlayService: any): void {

                    $scope.transition_name = transition_name;
                    $scope.type = that.process.type;
                    $scope.approve = () => {

                    let subType = '';
                    if (that.process.type === 'document' || that.process.type === 'leave') {
                        subType = that.process.extra.data['type'];
                    }

                    that.$scope.$emit('$EL', 'requests.item.' +  transition_name + '.'+that.process.type, subType);

                    
                    $uibModalInstance.close($scope.note);
                    
                    };
                }
            ],

            templateUrl: templateUrl
        });

        modalInstance.result.then((note: string) => {
            this.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            if (this.process.extra['transitions'].length > 0) {
                this.Process.transition(this.process.id, {
                    transition: transition_name,
                    data: {}
                }).then((response: any) => {

                    if (response.completed) {
                        this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                        this.toaster.pop('success', 'Completed', 'Proceess is already completed');
                    } else {
                        this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                        this.toaster.pop('success', 'Success', 'Transition to the next step is successful');
                    }

                    this.$state.go('^');

                }, 
                (response: any) => {
                    if (response.status === 400) {
                        this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                        this.toaster.pop('error', 'Validation Failed', response.data);
                    } else {
                        this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                        this.toaster.pop('error', 'Server error', response.data.detail);
                    }
                });

            } else {
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                this.toaster.pop('success', 'Completed', 'Proceess is already completed');
                this.$state.go('^');
            }
        });

    }


    public selectEditProcess(): void {
        let subType = '';
        if (this.process.type === 'document' || this.process.type === 'leave') {
            subType = this.process.extra.data['type'];
        }
        this.$scope.$emit('$EL', 'requests.item.edit.' + this.process.type, subType);
        this.$state.go('root.processes.edit', { id: this.process.id});
    }


    public showViewCalendarModal(): void {
        var p_event: any = {
            calendar_type: 'leaves',
            event_type: 'proposed',
            title: 'Proposed ' + this.process.type + ' for ' + this.process.employee.displayname,
            start: moment.utc(this.process.extra.data.start_date + ' 00:00:00'),
            end: moment.utc(this.process.extra.data.end_date + ' 23:59:59'),
            event_id: -1,
            rule: '',
            tempObj: {
                allDay: true,
                dayDifference: 0,
                eventIsPast: false,
                multiDay: false
            },
            color: 'rgba(228, 100, 100, 0.5)',
        };

        this.state.params['provisional_event'] = p_event;
        var dura: any = moment.duration(p_event.end.diff(p_event.start));
        var hrs: any = Math.round(dura.asHours());
        var dayDifference: number;
        if (hrs > 24) {
            p_event.tempObj.allDay = true;
            p_event.tempObj.multiDay = false;
            if (p_event.end.isAfter(p_event.start, 'day')) {
                let start_dt: any = moment.utc(p_event.start);
                start_dt.startOf('day');
                let end_dt: any = moment.utc(p_event.end);
                end_dt.startOf('day');
                dayDifference = end_dt.diff(start_dt, 'days') + 1;
                p_event.tempObj.allDay = true;
                p_event.tempObj.multiDay = true;
            }
        } else if (hrs === 24) {
            p_event.tempObj.allDay = true;
            p_event.tempObj.multiDay = false;
        } else {
            p_event.tempObj.allDay = false;
            p_event.tempObj.multiDay = false;
        }
    
        p_event.tempObj.dayDifference = dayDifference;
        let eveOverToday: Boolean = moment().isBefore(p_event.end, 'minute'); 
        if (eveOverToday === false) {
            p_event.tempObj.eventIsPast = false;
        } else if (eveOverToday) {
            p_event.tempObj.eventIsPast = true;
        }

        let modalInstance: any = this.$uibModal.open({
            controller: 'PrivateCalendarController as C',
            controllerAs: 'C',
            templateUrl: '/static/templates/calendar/index.html'
        });

        modalInstance.result.then(() => {});
    }
    
    public isDate(date: any): boolean {
        let val: Moment = moment(date, 'YYYY-MM-DD', true);
        return val.isValid();
    }

}

angular.module('beneple.process')
    .controller('ProcessDetailController', ProcessDetailController);



// WEBPACK FOOTER //
// ./frontend/scripts/process/controllers/process_detail.controller.ts